
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"8","height":"14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M.268 7.176c.02.224.11.435.255.606l4.898 5.73a1.087 1.087 0 0 0 1.857-.34c.13-.369.055-.78-.199-1.076L2.785 7.074l4.294-5.022A1.094 1.094 0 0 0 6.448.268c-.384-.07-.775.07-1.027.369L.523 6.367c-.191.224-.283.516-.255.81z","fill":"#0E1F12","fill-rule":"nonzero"}})])
      }
    
      }
    